import template from './document-preview.pug';

export const DocumentPreviewModalComponent = {
  template,
  bindings:{
    resolve: '<',
    modalInstance: '<',
  },
  controller: class DocumentPreviewModalComponent {
    constructor(Document, AlertBox, $async, $log) {
      'ngInject';

      this.Document = Document;
      this.$log = $log;
      this.AlertBox = AlertBox;
      this.moveToTrash = $async(this.moveToTrash.bind(this));
      this.update = $async(this.update.bind(this));

      this.formState = 'show';
    }

    $onInit() {
      this.record = this.resolve.record;
    }

    close() {
      this.modalInstance.close(void(0));
    }

    changeFormState(state) {
      if (state == 'edit') {
        this.record = angular.copy(this.record);
      }
      this.formState = state;
    }

    async moveToTrash() {
      try {
        await this.Document.moveToTrash(this.record.id);
        this.AlertBox.addMessage('alert.deleted', { type: 'success' });
        this.close();
      } catch (e) {
        this.$log.error(e);
      }
    }

    async update({ document }) {
      try {
        const resp = await this.Document.update(document);
        if (resp && resp.data && resp.data.id) {
          this.record = resp.data;
          this.AlertBox.addMessage('alert.updated', { type: 'success' });
          this.changeFormState('show');
        }
      } catch (e) {
        this.$log.error(e);
      }
    }
  }
};
